import React from "react";
import SiteVisitSummary from "../dashboard/SiteVisitSummary/SiteVisitSummary";

/**
 * Standalone route for the Site Visit Summary (sidebar → Site Visit Summary).
 *
 * The board itself is the same component the project Home page embeds, so the
 * inline editing and the columns stay in one place. The route exists so the
 * sidebar can open the board directly; the header breadcrumb names the page, so
 * there is nothing above the table.
 */
const SiteVisitSummaryPage = () => <SiteVisitSummary />;

export default SiteVisitSummaryPage;
